<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="col-md-12">
          <img src="static/img/logo.webp" class="img-fluid" style="width: 30%; height: 30%;" alt="">
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page" >
      <div class="full-page login-page" >
        <div class="content" style="background-color:#302254;">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-5 col-md-offset-3 col-sm-offset-3">
                <form  @submit.prevent="login()">
                  <div class="card" style="padding:10px;">
                    <br>
                    <div class="alert alert-danger" v-if="mensaje!=null" style="color: rgb(47, 34, 84); background-color: rgb(158, 137, 213); font-size:17px; margin: 10px 15px;"><span>{{mensaje}} <i :class="'fa fa-'+icono"></i></span></div>
                    <div class="card-header">
                      <span style="font-size:25px; font-weight: 400;">Inicia sesión en avanti</span> <br>
                      <span style="font-size: 15px; color: gray; font-weight: 200;"> Inicia sesión con el usuario y contraseña que te asignaron </span>
                    </div>
                    <div class="card-content">
                  
                      <div class="form-group">
                        <label for="usuario">Usuario</label>
                        <input type="text" id="usuario" placeholder="Ingrese su usuario" required v-model="usuario" class="form-control input-lg input-no-border">
                      </div>
                      <div class="form-group">
                        <label for="clave">Contaseña</label>
                        <input type="password" id="clave" placeholder="Ingrese su clave" required v-model="password" class="form-control input-lg input-no-border">
                      </div>
                    
                      {{error}}
                    </div>
                    <div class="card-footer">
                      <button type="submit" class="btn btn-fill btn-lg btn-wd btn-block" style="border-radius: 0px;">Iniciar sesión</button>
                      <div style="background-color: #edededb5; margin: 25px 0px; border-radius: 7px; padding:10px; color:gray">
                        <span> <i class="fa fa-close"> </i> Recuerda no compartir tus datos de acceso </span> <br> <br>
                        <span> <i class="fa fa-info"> </i> Si no recuerdas tu clave, avisa al administrador </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer" style="background-color:#302254;">
          <div class="container">
            <!-- <div class="copyright">
             AVANTI v11 &nbsp;&nbsp;  Desarrollado por Avanza IPS <a> - 2019</a>.
            </div> -->

            <div class="copyright">
              AVANTI v11 &nbsp;&nbsp;  Desarrollado por Avanza IPS <a> - 2019</a>.
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from "axios";
  export default {

    data(){
      return {
        usuario : '',
        password : '',
        token : '',
        ip : 'https://avanti-erp.com/',
        error: '',
        mensaje: null,
        icono: null
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      login () {

      this.mensaje = 'Iniciando sesión...'
      this.icono = 'spinner'
      axios.post(this.ip+'api/login',{
        'usuario' : this.usuario,
        'password' : this.password
      })
        .then (response => {
        
         if(response.data.status == true){
          this.token = response.data.token
          localStorage.setItem('token' , this.token)
          localStorage.setItem('emailsProgramacion', JSON.stringify(response.data.emails));
          localStorage.setItem('usuario' , response.data.usuario[0].usuario);
          localStorage.setItem('rol' , response.data.usuario[0].id_rol);
          localStorage.setItem('email', response.data.usuario[0].email);
          localStorage.setItem('foto', response.data.usuario[0].url_foto);
          localStorage.setItem('sede', response.data.usuario[0].sede);
          localStorage.setItem('nombre', response.data.usuario[0].nombres + ' ' + response.data.usuario[0].apellidos);
          localStorage.setItem('firmaElectronica', response.data.usuario[0].UsuFirEle)
          if(response.data.usuario[0].id_rol==1){
            this.$router.push('/dashboard/avanti')
          }
          else if(response.data.usuario[0].id_rol==7){
            this.$router.push('/programacion/programacion-citas')
          }else if(response.data.usuario[0].id_rol==8){
             this.$router.push('/reportes/pacientes')
          }
          else if(response.data.usuario[0].id_rol==9){
            this.$router.push('/programacion/programacion-citas')
          }
          else if(response.data.usuario[0].id_rol==14){
            this.$router.push('/dashboard/avanti')
          }
          else if(response.data.usuario[0].id_rol==10){
            this.$router.push('/historiaClinica/historia')
          }
          else{
            this.$router.push('/diarioCampo/evoluciones')
          }
          location.reload()
          }
         
         if(response.data.status == false){
           this.mensaje = 'Usuario o contraseña incorrectos!'
           this.icono = 'close'
           this.password = '';
         }
        //  console.log(response)
        })
        .catch (e => {
          console.log(e);
        });
    },
    beforeDestroy () {
      this.closeMenu()
    }
    
  },
  mounted() {
    document.title = 'Avanti | Login';
    localStorage.removeItem('PacienteHC');
    localStorage.removeItem('PacienteId');
    localStorage.removeItem("PacienteNombre");
  }
  }
</script>
<style scoped>

.btn {
  border-radius: 5px !important;
}

.card {
  border-radius: 15px !important;
  width: 100% !important;
}

label{
  font-weight: normal;
}

</style>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue